export const objectIdToNumber = (str = '') => Number(str.toString().replace(/^0+(?=\d)/, ''));
